<script lang="ts" setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useAppStore } from "@/store/app.store";

const emit = defineEmits<{
  (e: "reconnect"): void;
}>();

const { t } = useI18n();
const appStore = useAppStore();

const isSocketConnectionLost = computed(() => appStore.socketConnectionLost);
</script>

<template>
  <v-snackbar
    :model-value="isSocketConnectionLost"
    :timeout="-1"
    class="socket-error-snackbar"
    color="#FF5252"
    location="bottom"
    rounded="0"
    variant="flat"
  >
    {{ t("general.socket-connection-lost") }}
    <template #actions>
      <v-btn variant="outlined" @click="emit('reconnect')">{{ t("general.reconnect") }}</v-btn>
    </template>
  </v-snackbar>
</template>

<style lang="scss">
.socket-error-snackbar {
  margin: 0;

  .v-snackbar__wrapper {
    width: 100%;
  }
}
</style>
